module.exports = __webpack_public_path__ + "4.dfbb8138.png";


//////////////////
// WEBPACK FOOTER
// ./client/images/story/4.png
// module id = 689
// module chunks = 0